export default __webpack_public_path__ + "static/media/QV_NozzleBlob.bd2fd001.jpg";